import { combineReducers } from "@reduxjs/toolkit";
import settings from "./settings/Reducer";
import auth from "./auth/Reducer";
import finance from "./finance/Reducer";
import site from "./app/Reducer";
import transactionsReducer from "./transactions/transactionsSlice";
import companiesReducer from "./companies/companySlice";
import routerHistoryReducer from "./routerHistory/routerHistorySlice";
import app from "./app/appSlice";
import { dashboardApi } from "./dashboard/dashboardApi";
import modals from "./modals/modalsSlice";
import { settingsApi } from "./settings/settingsApi";
import { dashboardSlice } from "./dashboard/dashboardSlice";
const Reducers = combineReducers({
  settings,
  auth,
  site,
  finance,
  transactions: transactionsReducer,
  companies: companiesReducer,
  routerHistory: routerHistoryReducer,
  app,
  [dashboardApi.reducerPath]: dashboardApi.reducer,
  [dashboardSlice.name]: dashboardSlice.reducer,
  modals,
  [settingsApi.reducerPath]: settingsApi.reducer,
});

export default Reducers;
